import { Global, MiddlewareConsumer, Module, NestModule } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { BrandingModule } from '../branding/branding.module';
import { StoreContextMiddleware } from './store-context.middleware';
import { StoreContextService } from './store-context.service';
import { StoreConfigService } from './store-config.service';
import { StoreSitemapService } from './store-sitemap.service';
import { StoreInfoController } from './store-info.controller';

@Global()
@Module({
  // BrandingModule, so /store/config can carry the storefront's SEO in the
  // same round trip the theme arrives in — see StoreConfigService.load().
  imports: [BrandingModule],
  controllers: [StoreInfoController],
  // StoreConfigService is exported so StorefrontTemplatesService can invalidate
  // its cache the moment a template is applied, published or removed.
  providers: [PrismaService, StoreContextService, StoreConfigService, StoreSitemapService],
  exports: [PrismaService, StoreContextService, StoreConfigService, StoreSitemapService],
})
export class TenancyModule implements NestModule {
  configure(consumer: MiddlewareConsumer): void {
    // Must run before any guard that reads StoreContextService (e.g.
    // AdminAccessGuard) — see store-context.middleware.ts for why this has
    // to be middleware rather than an interceptor.
    consumer.apply(StoreContextMiddleware).forRoutes('*');
  }
}
